export const mockData1 = {
  meta: {
    code: 200,
    message: 'OK',
  },
  data: {
    simpleUsers: [
      {
        name: 'vv',
        url: 'http://cloud.omi.dev.p1.cn/v1/images/eyJpZCI6IjdCSklNVjM0NFlGVDdWMklWVTdWNk9EV1lGWlFMViIsInciOjEwODAsImgiOjE0NDAsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMjQ5MDI5ODYzNjQyNzM3MzExMywiYWIiOjB9',
      },
    ],
  },
  pagination: {
    total: 0,
    limit: 20,
    links: {
      previous: null,
      next: null,
    },
  },
};

export const mockData2: any = {
  meta: {
    code: 200,
    message: 'OK',
  },
  data: {
    merchandises: [
      {
        id: '34',
        type: 'merchandise',
        category: 'vip',
        quantity: 12,
        unit: 'months',
        productType: 'auto-renewable',
        defaultStockKeepUnits: [
          {
            id: '132',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 1520.0,
                'non-renewing': 1690.0,
              },
              inAppPrice: 1690.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
      },
      {
        id: '28',
        type: 'merchandise',
        category: 'supreme',
        quantity: 12,
        unit: 'months',
        productType: 'auto-renewable',
        defaultStockKeepUnits: [
          {
            id: '138',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 6750.0,
                'non-renewing': 7490.0,
              },
              inAppPrice: 7490.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
        // promotionStockKeepUnits: [
        //   {
        //     id: '100212',
        //     type: 'stockKeepUnit',
        //     affiliateProducts: null,
        //     prices: {
        //       currencySymbol: 'NT$',
        //       currencyCode: 'TWD',
        //       tagPrice: {
        //         default: 6750.00,
        //         'high-renewal': 6750.00,
        //         'low-fee': 6750.00,
        //         'non-renewing': 6750.00,
        //       },
        //       inAppPrice: 7490.00,
        //       price: 0.00,
        //       unitPrice: 0.00,
        //       originalPrice: 0.00,
        //       originalUnitPrice: 0.00,
        //       noneRenewalPrice: 0.00,
        //       noneRenewalUnitPrice: 0.00,
        //       discount: 0,
        //       discountPercent: 0,
        //     },
        //   },
        // ],
      },
      {
        id: '1',
        type: 'merchandise',
        category: 'seeWhoLikedMe',
        quantity: 12,
        unit: 'months',
        productType: 'auto-renewable',
        defaultStockKeepUnits: [
          {
            id: '135',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 3060.0,
                'non-renewing': 3390.0,
              },
              inAppPrice: 3390.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
        // promotionStockKeepUnits: [
        //   {
        //     id: '100209',
        //     type: 'stockKeepUnit',
        //     affiliateProducts: null,
        //     prices: {
        //       currencySymbol: 'NT$',
        //       currencyCode: 'TWD',
        //       tagPrice: {
        //         default: 3060.00,
        //         'high-renewal': 3060.00,
        //         'low-fee': 3060.00,
        //         'non-renewing': 3060.00,
        //       },
        //       inAppPrice: 3390.00,
        //       price: 0.00,
        //       unitPrice: 0.00,
        //       originalPrice: 0.00,
        //       originalUnitPrice: 0.00,
        //       noneRenewalPrice: 0.00,
        //       noneRenewalUnitPrice: 0.00,
        //       discount: 0,
        //       discountPercent: 0,
        //     },
        //   },
        // ],
      },
      {
        id: '32',
        type: 'merchandise',
        category: 'vip',
        quantity: 3,
        unit: 'months',
        productType: 'auto-renewable',
        defaultStockKeepUnits: [
          {
            id: '131',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 510.0,
                'non-renewing': 560.0,
              },
              inAppPrice: 560.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
        // promotionStockKeepUnits: [
        //   {
        //     id: '100214',
        //     type: 'stockKeepUnit',
        //     affiliateProducts: null,
        //     prices: {
        //       currencySymbol: 'NT$',
        //       currencyCode: 'TWD',
        //       tagPrice: {
        //         default: 510.00,
        //         'high-renewal': 510.00,
        //         'low-fee': 510.00,
        //         'non-renewing': 510.00,
        //       },
        //       inAppPrice: 560.00,
        //       price: 0.00,
        //       unitPrice: 0.00,
        //       originalPrice: 0.00,
        //       originalUnitPrice: 0.00,
        //       noneRenewalPrice: 0.00,
        //       noneRenewalUnitPrice: 0.00,
        //       discount: 0,
        //       discountPercent: 0,
        //     },
        //   },
        // ],
      },
      {
        id: '27',
        type: 'merchandise',
        category: 'supreme',
        quantity: 3,
        unit: 'months',
        productType: 'auto-renewable',
        defaultStockKeepUnits: [
          {
            id: '137',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 2330.0,
                'non-renewing': 2590.0,
              },
              inAppPrice: 2590.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
        // promotionStockKeepUnits: [
        //   {
        //     id: '100211',
        //     type: 'stockKeepUnit',
        //     affiliateProducts: null,
        //     prices: {
        //       currencySymbol: 'NT$',
        //       currencyCode: 'TWD',
        //       tagPrice: {
        //         default: 2330.00,
        //         'high-renewal': 2330.00,
        //         'low-fee': 2330.00,
        //         'non-renewing': 2330.00,
        //       },
        //       inAppPrice: 2590.00,
        //       price: 0.00,
        //       unitPrice: 0.00,
        //       originalPrice: 0.00,
        //       originalUnitPrice: 0.00,
        //       noneRenewalPrice: 0.00,
        //       noneRenewalUnitPrice: 0.00,
        //       discount: 0,
        //       discountPercent: 0,
        //     },
        //   },
        // ],
      },
      {
        id: '2',
        type: 'merchandise',
        category: 'seeWhoLikedMe',
        quantity: 3,
        unit: 'months',
        productType: 'auto-renewable',
        defaultStockKeepUnits: [
          {
            id: '134',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 1020.0,
                'non-renewing': 1120.0,
              },
              inAppPrice: 1120.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
        // promotionStockKeepUnits: [
        //   {
        //     id: '100208',
        //     type: 'stockKeepUnit',
        //     affiliateProducts: null,
        //     prices: {
        //       currencySymbol: 'NT$',
        //       currencyCode: 'TWD',
        //       tagPrice: {
        //         default: 1020.00,
        //         'high-renewal': 1020.00,
        //         'low-fee': 1020.00,
        //         'non-renewing': 1020.00,
        //       },
        //       inAppPrice: 1120.00,
        //       price: 0.00,
        //       unitPrice: 0.00,
        //       originalPrice: 0.00,
        //       originalUnitPrice: 0.00,
        //       noneRenewalPrice: 0.00,
        //       noneRenewalUnitPrice: 0.00,
        //       discount: 0,
        //       discountPercent: 0,
        //     },
        //   },
        // ],
      },
      {
        id: '33',
        type: 'merchandise',
        category: 'vip',
        quantity: 1,
        unit: 'months',
        productType: 'auto-renewable',
        defaultStockKeepUnits: [
          {
            id: '130',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 255.0,
                'non-renewing': 280.0,
              },
              inAppPrice: 280.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
        // promotionStockKeepUnits: [
        //   {
        //     id: '100213',
        //     type: 'stockKeepUnit',
        //     affiliateProducts: null,
        //     prices: {
        //       currencySymbol: 'NT$',
        //       currencyCode: 'TWD',
        //       tagPrice: {
        //         default: 255.00,
        //         'high-renewal': 255.00,
        //         'low-fee': 255.00,
        //         'non-renewing': 255.00,
        //       },
        //       inAppPrice: 280.00,
        //       price: 0.00,
        //       unitPrice: 0.00,
        //       originalPrice: 0.00,
        //       originalUnitPrice: 0.00,
        //       noneRenewalPrice: 0.00,
        //       noneRenewalUnitPrice: 0.00,
        //       discount: 0,
        //       discountPercent: 0,
        //     },
        //   },
        // ],
      },
      {
        id: '3',
        type: 'merchandise',
        category: 'seeWhoLikedMe',
        quantity: 1,
        unit: 'months',
        productType: 'auto-renewable',
        defaultStockKeepUnits: [
          {
            id: '133',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 510.0,
                'non-renewing': 560.0,
              },
              inAppPrice: 560.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
        discountStockKeepUnits: [
          {
            id: '100207',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 510.0,
                'high-renewal': 510.0,
                'low-fee': 510.0,
                'non-renewing': 510.0,
              },
              inAppPrice: 560.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
      },
      {
        id: '26',
        type: 'merchandise',
        category: 'supreme',
        quantity: 1,
        unit: 'months',
        productType: 'auto-renewable',
        defaultStockKeepUnits: [
          {
            id: '136',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 1140.0,
                'non-renewing': 1260.0,
              },
              inAppPrice: 1260.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
        // promotionStockKeepUnits: [
        //   {
        //     id: '100210',
        //     type: 'stockKeepUnit',
        //     affiliateProducts: null,
        //     prices: {
        //       currencySymbol: 'NT$',
        //       currencyCode: 'TWD',
        //       tagPrice: {
        //         default: 1140.00,
        //         'high-renewal': 1140.00,
        //         'low-fee': 1140.00,
        //         'non-renewing': 1140.00,
        //       },
        //       inAppPrice: 1260.00,
        //       price: 0.00,
        //       unitPrice: 0.00,
        //       originalPrice: 0.00,
        //       originalUnitPrice: 0.00,
        //       noneRenewalPrice: 0.00,
        //       noneRenewalUnitPrice: 0.00,
        //       discount: 0,
        //       discountPercent: 0,
        //     },
        //   },
        // ],
      },
      {
        id: '123',
        type: 'merchandise',
        category: 'diamond',
        quantity: 1,
        unit: 'months',
        productType: 'auto-renewable',
        tag: 'hot', // 标签 hot - hot, bestDeal - 最划算
        channels: [
          // 支持的渠道id
          '1',
          '2',
          '5',
          '6',
        ],
        defaultStockKeepUnits: [
          {
            id: '136',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 1140.0,
                'non-renewing': 1260.0,
              },
              inAppPrice: 1260.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
      },
      {
        id: '1234',
        type: 'merchandise',
        category: 'diamond',
        quantity: 1,
        unit: 'months',
        productType: 'auto-renewable',
        tag: 'hot', // 标签 hot - hot, bestDeal - 最划算
        channels: [
          // 支持的渠道id
          '1',
          '2',
          '5',
          '6',
        ],
        defaultStockKeepUnits: [
          {
            id: '136',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 1140.0,
                'non-renewing': 1260.0,
              },
              inAppPrice: 1260.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
      },
      {
        id: '1233',
        type: 'merchandise',
        category: 'diamond',
        quantity: 1,
        unit: 'months',
        productType: 'auto-renewable',
        tag: 'hot', // 标签 hot - hot, bestDeal - 最划算
        channels: [
          // 支持的渠道id
          '1',
          '2',
          '5',
          '6',
        ],
        defaultStockKeepUnits: [
          {
            id: '136',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 1140.0,
                'non-renewing': 1260.0,
              },
              inAppPrice: 1260.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
      },
      {
        id: '1235',
        type: 'merchandise',
        category: 'diamond',
        quantity: 1,
        unit: 'months',
        productType: 'auto-renewable',
        tag: 'hot', // 标签 hot - hot, bestDeal - 最划算
        channels: [
          // 支持的渠道id
          '1',
          '2',
          '5',
          '6',
        ],
        defaultStockKeepUnits: [
          {
            id: '136',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 1140.0,
                'non-renewing': 1260.0,
              },
              inAppPrice: 1260.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
      },
      {
        id: '1236',
        type: 'merchandise',
        category: 'diamond',
        quantity: 1,
        unit: 'months',
        productType: 'auto-renewable',
        tag: 'hot', // 标签 hot - hot, bestDeal - 最划算
        channels: [
          // 支持的渠道id
          '1',
          '2',
          '5',
          '6',
        ],
        defaultStockKeepUnits: [
          {
            id: '136',
            type: 'stockKeepUnit',
            affiliateProducts: null,
            prices: {
              currencySymbol: 'NT$',
              currencyCode: 'TWD',
              tagPrice: {
                default: 1140.0,
                'non-renewing': 1260.0,
              },
              inAppPrice: 1260.0,
              price: 0.0,
              unitPrice: 0.0,
              originalPrice: 0.0,
              originalUnitPrice: 0.0,
              noneRenewalPrice: 0.0,
              noneRenewalUnitPrice: 0.0,
              discount: 0,
              discountPercent: 0,
            },
          },
        ],
      },
    ],
  },
  pagination: {
    total: 0,
    limit: 0,
    links: {
      previous: null,
      next: null,
    },
  },
};

export const mockData3: any = {
  meta: {
    code: 200,
    message: 'OK',
  },
  data: {
    paymentChannels: [
      {
        id: '28',
        platform: 'payermax',
        paymentMethod: 'ONE_TOUCH',
        targetOrg: 'DANA',
        desc: 'DANA',
        enableSubscription: true,
        discountable: true,
        tags: ['low-fee', 'high-renewal'],
        picture:
          'https://auto.omicdn.com/v1/images/eyJpZCI6IlRWU0ZUWU5EWFNYU040M0Y2NlFUQ0RRSVBFQjRENSIsInciOjQzMiwiaCI6MjE2LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MjE2MTc2MzY5NzcyNzI0MjI3LCJhYiI6MH0.png',
        enableUpgrade: true,
      },
      {
        id: '39',
        platform: 'checkout',
        paymentMethod: 'card',
        targetOrg: '',
        desc: 'Credit Card',
        enableSubscription: true,
        discountable: true,
        tags: ['high-renewal'],
        picture:
          'https://auto.omicdn.com/v1/images/eyJpZCI6IkdIRUhXTUtGRVNZQ0tLUTQ0R0VJTkpPQkpQMlpGSSIsInciOjQzMiwiaCI6MjE2LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MjMxNDkwNjY1NzU0Nzc0NzMyOCwiYWIiOjB9.png',
        enableUpgrade: true,
      },
      {
        id: '43',
        platform: 'checkout',
        paymentMethod: 'applepay',
        targetOrg: '',
        desc: 'Apple Pay',
        enableSubscription: true,
        discountable: true,
        tags: ['high-renewal'],
        picture:
          'https://auto.omicdn.com/v1/images/eyJpZCI6IlFZTzNHUjVYTDdZUEtVUFZNNkVRSEk0NldQTVhVSiIsInciOjQzMiwiaCI6MjE2LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6NDIzNjkyMjgyMzc4NjY0OTYsImFiIjowfQ.png',
        enableUpgrade: true,
      },
    ],
  },
};

export const mockData4: any = {
  meta: {
    code: 200,
    message: 'OK',
  },
  data: {
    orders: [
      {
        id: '185111',
        amount: 510,
        currencyCode: 'TWD',
        duration: 300,
        createdTime: 1714385044614,
        platform: 'checkout',
        productType: 'seeWhoLikedMe',
        productId: '160',
        transactionId: 'pay_nd44j3zbdd3utjaekrezx5mg2q',
        orderStatus: 'success',
        originalTransactionId: 'pay_nd44j3zbdd3utjaekrezx5mg2q',
        affiliateProductId: '817',
      },
    ],
  },
};

export const mockData5: any = {
  meta: {
    code: 200,
    message: 'OK',
  },
  data: {
    upgradeOrders: [
      {
        orderId: '84',
        upgradeAmount: 240.0,
        offsetAmount: 40.0,
      },
    ],
  },
};
